import React from "react";
import PropTypes from "prop-types";
import { injectGlobal } from "styled-components";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Helmet } from "react-helmet";
import { ShortcutManager } from "react-shortcuts";
import { DragDropContextProvider } from "react-dnd";
import DnDHTML5Backend from "react-dnd-html5-backend";
import keymap from "./keymap.js";
import * as colors from "./settings/colors";

import HelpWidget from "./components/HelpWidget";
import AuthRoute from "./components/AuthRoute";
import Index from "./components/Index";
import Login from "./components/Login";
import RequestPasswordReset from "./components/RequestPasswordReset";
import ResetPassword from "./components/ResetPassword";
import AcceptInvitation from "./components/AcceptInvitation";
import AdminSidebar from "./components/admin/Sidebar";
import FranchiseSidebar from "./components/franchise/Sidebar";
import MainPanel from "./components/MainPanel";
import AdminRoutes from "./components/admin/Routes";
import FranchiseRoutes from "./components/franchise/Routes";

import "react-select/dist/react-select.css";

injectGlobal`
  html {
    font-size: 14px;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica",
      "Arial", sans-serif;
    color: ${colors.TEXT};
  }

  body {
    margin: 0;
  }

  [tabindex="-1"] {
    outline: 0;
  }
`;

const buildTitle = (...tokens) => tokens.filter(t => !!t).join(" ");

const prefix = process.env.NODE_ENV === "development" && "[DEV]";
const baseTitle = "Archadeck Logbook";
const defaultTitle = buildTitle(prefix, baseTitle);
const titleTemplate = buildTitle(prefix, "%s", "|", baseTitle);

const AppContents = () => (
  <div>
    <Switch>
      <Route path="/admin" component={AdminSidebar} />
      <Route path="/:franchiseSlug" component={FranchiseSidebar} />
    </Switch>
    <MainPanel>
      <Switch>
        <Route path="/admin" component={AdminRoutes} />
        <Route path="/:franchiseSlug" component={FranchiseRoutes} />
      </Switch>
    </MainPanel>
  </div>
);

const shortcutManager = new ShortcutManager(keymap);

class App extends React.Component {
  getChildContext() {
    return { shortcuts: shortcutManager };
  }

  render() {
    return (
      <Router>
        <DragDropContextProvider backend={DnDHTML5Backend}>
          <div className="app-wrapper">
            <Helmet defaultTitle={defaultTitle} titleTemplate={titleTemplate} />
            <Switch>
              <Route path="/login" component={Login} />
              <Route
                exact
                path="/reset-password"
                component={RequestPasswordReset}
              />
              <Route
                exact
                path="/invitation/:token"
                component={AcceptInvitation}
              />
              <Route path="/reset-password/:token" component={ResetPassword} />
              <AuthRoute exact path="/" component={Index} />
              <AuthRoute component={AppContents} />
            </Switch>
            <HelpWidget />
          </div>
        </DragDropContextProvider>
      </Router>
    );
  }

  static childContextTypes = {
    shortcuts: PropTypes.object.isRequired
  };
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js